import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import "../../asstes/styles/privateCouncilInside.scss";

const PrivateCouncilInside = () => {

    const cardContents = [
        {
            text: "What becomes visible is what the decision will ask you to face: without exit, without rationale, without return. This confrontation is where clarity lives.",
            bottom: "This is not an experience. It is a confrontation with answerability."
        },
        {
            text: "Every moment inside the council strips away illusion and exposes the weight of truth beneath ambition.",
            bottom: "There is no performance here. Only precision."
        },
        {
            text: "The room does not provide certainty. It reveals the cost of avoiding what is already known.",
            bottom: "Clarity begins where comfort ends."
        }
    ];

    const [activeIndex, setActiveIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        if (isPaused) return;

        const interval = setInterval(() => {
            setActiveIndex((prev) =>
                prev === cardContents.length - 1 ? 0 : prev + 1
            );
        }, 4500);

        return () => clearInterval(interval);
    }, [isPaused, cardContents.length]);

    return (
        <section className="private-inside-section"> 
            <div className="container">
                <div className="inside-wrapper row align-items-center">

                    <div className="col-lg-6">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, y: 80 }}
                            whileInView={{ opacity: 1, scale: 1, y: 0 }}
                            transition={{ duration: 1 }}
                            viewport={{ once: true }}
                            className="left-content"
                        >
                            <div className="section-tag">
                                <span></span>
                                INSIDE THE COUNCIL
                            </div>

                            <h2 className="main-title">
                                What <span>Happens</span>
                            </h2>

                            <div className="list-area">

                                <motion.div
                                    initial={{ opacity: 0, x: -40 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.6, delay: 0.2 }}
                                    viewport={{ once: true }}
                                    className="list-item"
                                >
                                    <span></span>
                                    <p>No advice is given.</p>
                                </motion.div>

                                <motion.div
                                    initial={{ opacity: 0, x: -40 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.8, delay: 0.3 }}
                                    viewport={{ once: true }}
                                    className="list-item"
                                >
                                    <span></span>
                                    <p>No reassurance is offered.</p>
                                </motion.div>

                                <motion.div
                                    initial={{ opacity: 0, x: -40 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.4 }}
                                    viewport={{ once: true }}
                                    className="list-item"
                                >
                                    <span></span>
                                    <p>No outcomes are promised.</p>
                                </motion.div>

                            </div>
                        </motion.div>
                    </div>

                    <div className="col-lg-6">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.7, rotate: 3 }}
                            whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
                            transition={{ duration: 1 }}
                            viewport={{ once: true }}
                            className="info-card"
                            onMouseEnter={() => setIsPaused(true)}
                            onMouseLeave={() => setIsPaused(false)}
                        >
                            <div className="corner top-left"></div>
                            <div className="corner top-right"></div>
                            <div className="corner bottom-left"></div>
                            <div className="corner bottom-right"></div>

                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={activeIndex}
                                    initial={{
                                        opacity: 0,
                                        y: 30,
                                        filter: "blur(10px)"
                                    }}
                                    animate={{
                                        opacity: 1,
                                        y: 0,
                                        filter: "blur(0px)"
                                    }}
                                    exit={{
                                        opacity: 0,
                                        y: -30,
                                        filter: "blur(10px)"
                                    }}
                                    transition={{
                                        duration: 0.9,
                                        ease: "easeInOut"
                                    }}
                                    className="card-content-wrapper"
                                >
                                    <p className="card-text">
                                        {cardContents[activeIndex].text}
                                    </p>

                                    <div className="line-divider"></div>

                                    <p className="bottom-text">
                                        {cardContents[activeIndex].bottom}
                                    </p>
                                </motion.div>
                            </AnimatePresence>
                        </motion.div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default PrivateCouncilInside;